import {
  CBUImporter,
  CADETESImporter,
  ImporterStatus,
  ProductsImporter,
  VouchersImporter,
  AffiliateImporter,
  PrescriptionImporter,
  VouchersDetailsImporter,
  CBUProcessingData,
  AffiliateProcessingData,
} from '@/interfaces/imports';

import { safeRequest } from './user.service';
import { PaginatedResponse } from '@/interfaces/response';
import { AxiosPromise } from 'axios';
import request from '@/umi-request';
import { DetailError } from '@/interfaces/dni';

// CBU IMPORTER
export async function uploadCBUImportFiles(data: any) {
  return request({
    url: `cbu-processing/`,
    method: 'POST',
    data
  }) as AxiosPromise<CBUImporter>;
}

export async function getCBUImportFiles(params: any) {
  return request({
    url: `cbu-processing/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<CBUImporter>>;
}

export async function getCBUImporterHistory(id: number) {
  return request({
    url: `cbu-processing/${id}/history/`,
    method: 'GET',
  }) as AxiosPromise<CBUImporter[]>;
}

export async function simulateCBUImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `cbu-processing/${id}/simulate/`,
    method: 'PATCH',
  });
}

export async function getSimulationCBUImportResults(id: number) {
  return request({
    url: `cbu-processing/${id}/simulation-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function cancelCBUImport(id: number) {
  return request({
    url: `cbu-processing/${id}/cancel/`,
    method: 'PUT'
  }) as AxiosPromise<CBUProcessingData>;
}

export async function getCBUImportStatus(id: number) {
  return request({
    url: `cbu-processing/${id}/status/`,
    method: 'GET'
  }) as AxiosPromise<ImporterStatus>;
}

// Revisar interfaz

export async function applyCBUImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `cbu-processing/${id}/apply/`,
    method: 'PATCH'
  });
}

export async function getApplyErrorsCBUImportResults(id: number) {
  return request({
    url: `cbu-processing/${id}/apply-errors/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function getApplyResultsCBUImportResults(id: number) {
  return request({
    url: `cbu-processing/${id}/apply-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

// Affiliate Importer

export async function uploadAffiliateImportFiles(data: any) {
  return request({
    url: `affiliate-processing/`,
    method: 'POST',
    data
  }) as AxiosPromise<AffiliateImporter>;
}

export async function getAffiliateImportFiles(params: any) {
  return request({
    url: `affiliate-processing/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<AffiliateImporter>>;
}

export async function getAffiliateImporterHistory(id: number) {
  return request({
    url: `affiliate-processing/${id}/history/`,
    method: 'GET'
  }) as AxiosPromise<AffiliateImporter[]>;
}

export async function simulateAffiliateImport(id: number) {
  return safeRequest({
    url: `affiliate-processing/${id}/simulate/`,
    method: 'PATCH'
  });
}

export async function getSimulationAffiliateImportResults(
  id: number
) {
  return request({
    url: `affiliate-processing/${id}/simulation-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function cancelAffiliateImport(id: number) {
  return request({
    url: `affiliate-processing/${id}/cancel/`,
    method: 'PUT'
  }) as AxiosPromise<AffiliateProcessingData>;
}

export async function getAffiliateImportStatus(id: number) {
  return request({
    url: `affiliate-processing/${id}/status/`,
    method: 'GET'
  }) as AxiosPromise<ImporterStatus>;
}

export async function applyAffiliateImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `affiliate-processing/${id}/apply/`,
    method: 'PATCH'
  });
}

export async function getApplyErrorsAffiliateImportResults(id: number) {
  return request({
    url: `affiliate-processing/${id}/apply-errors/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function getApplyResultsAffiliateImportResults(id: number) {
  return request({
    url: `affiliate-processing/${id}/apply-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

// CADETES IMPORTER

export async function uploadCADETESImportFiles(data: any) {
  return request({
    url: `cadetes-processing/`,
    method: 'POST',
    data
  }) as AxiosPromise<AffiliateImporter>;
}

export async function getCADETESImportFiles(params: any) {
  return request({
    url: `cadetes-processing/`,
    method: 'get',
    params
  }) as AxiosPromise<PaginatedResponse<CADETESImporter>>;
}

export async function getCADETESImporterHistory(id: number) {
  return request({
    url: `cadetes-processing/${id}/history/`,
    method: 'GET'
  }) as AxiosPromise<CADETESImporter[]>;
}

export async function simulateCADETESImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `cadetes-processing/${id}/simulate/`,
    method: 'PATCH',
  });
}

export async function getSimulationCADETESImportResults(id: number) {
  return request({
    url: `cadetes-processing/${id}/simulation-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function cancelCADETESImport(id: number) {
  return request({
    url: `cadetes-processing/${id}/cancel/`,
    method: 'PUT'
  }) as AxiosPromise<AffiliateProcessingData>;
}

export async function getCADETESImportStatus(id: number) {
  return request({
    url: `cadetes-processing/${id}/status/`,
    method: 'GET'
  }) as AxiosPromise<ImporterStatus>;
}

export async function applyCADETESImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `cadetes-processing/${id}/apply/`,
    method: 'PATCh'
  });
}

export async function getApplyErrorsCADETESImportResults(id: number) {
  return request({
    url: `cadetes-processing/${id}/apply-errors/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function getApplyResultsCADETESImportResults(id: number) {
  return request({
    url: `cadetes-processing/${id}/apply-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

// Prescription Importer

export async function uploadConsumptionImportFiles(data: any) {
  return request({
    url: `prescriptions-processing/`,
    method: 'POST',
    data
  }) as AxiosPromise<AffiliateImporter>;
}

export async function getConsumptionImportFiles(params: any) {
  return request({
    url: `prescriptions-processing/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<PrescriptionImporter>>;
}

export async function getConsumptionImporterHistory(id: number) {
  return request({
    url: `prescriptions-processing/${id}/history/`,
    method: 'GET'
  }) as AxiosPromise<PrescriptionImporter[]>;
}

export async function simulateConsumptionImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `prescriptions-processing/${id}/simulate/`,
    method: 'PATCH'
  });
}

export async function getSimulationConsumptionImportResults(id: number) {
  return request({
    url: `prescriptions-processing/${id}/simulation-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function cancelConsumptionImport(id: number) {
  return request({
    url: `prescriptions-processing/${id}/cancel/`,
    method: 'PUT',
  }) as AxiosPromise<PrescriptionImporter[]>;
}

export async function getConsumptionImportStatus(id: number) {
  return request({
    url: `prescriptions-processing/${id}/status/`,
    method: 'GET'
  }) as AxiosPromise<ImporterStatus>;
}

export async function applyConsumptionImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `prescriptions-processing/${id}/apply/`,
    method: 'PATCH'
  });
}

export async function getApplyErrorsConsumptionImportResults(id: number) {
  return request({
    url: `prescriptions-processing/${id}/apply-errors/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function getApplyResultsConsumptionImportResults(id: number) {
  return request({
    url: `prescriptions-processing/${id}/apply-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

// ------------------------------------------------------------------

// Products Importer

export async function uploadProductsImportFiles(data: any) {
  return request({
    url: `products-processing/`,
    method: 'POST',
    data
  }) as AxiosPromise<AffiliateImporter>;
}

export async function getProductsImportFiles(params: any) {
  return request({
    url: `products-processing/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<ProductsImporter>>;
}

export async function getProductsImporterHistory(id: number) {
  return request({
    url: `products-processing/${id}/history/`,
    method: 'GET'
  }) as AxiosPromise<ProductsImporter[]>;
}

export async function simulateProductsImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `products-processing/${id}/simulate/`,
    method: 'PATCH'
  });
}

export async function getSimulationProductsImportResults(
  id: number
) {
  return request({
    url: `products-processing/${id}/simulation-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function cancelProductsImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `products-processing/${id}/cancel/`,
    method: 'PUT',
  });
}

export async function getProductsImportStatus(id: number) {
  return request({
    url: `products-processing/${id}/status/`,
    method: 'GET'
  }) as AxiosPromise<ImporterStatus>;
}

export async function applyProductsImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `products-processing/${id}/apply/`,
    method: 'PATCH'
  });
}

export async function getApplyErrorsProductsImportResults(
  id: number
) {
  return request({
    url: `products-processing/${id}/apply-errors/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function getApplyResultsProductsImportResults(
  id: number
) {
  return request({
    url: `products-processing/${id}/apply-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function uploadVouchersImportFiles(data: any) {
  return request({
    url: `vouchers-processing/`,
    method: 'POST',
    data
  }) as AxiosPromise<AffiliateImporter>;
}

export async function getVouchersImportFiles(params: any) {
  return request({
    url: `vouchers-processing/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<ProductsImporter>>;
}

export async function getVouchersImporterHistory(id: number) {
  return request({
    url: `vouchers-processing/${id}/history/`,
    method: 'GET'
  }) as AxiosPromise<VouchersImporter[]>;
}

export async function simulateVouchersImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `vouchers-processing/${id}/simulate/`,
    method: 'PATCH'
  });
}

export async function getSimulationVouchersImportResults(
  id: number
) {
  return request({
    url: `vouchers-processing/${id}/simulation-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function cancelVouchersImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `vouchers-processing/${id}/cancel/`,
    method: 'PUT'
  });
}

export async function getVouchersImportStatus(id: number) {
  return request({
    url: `vouchers-processing/${id}/status/`,
    method: 'GET'
  }) as AxiosPromise<ImporterStatus>;
}

export async function applyVouchersImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `vouchers-processing/${id}/apply/`,
    method: 'PATCH'
  });
}

export async function getApplyErrorsVouchersImportResults(
  id: number
) {
  return request({
    url: `vouchers-processing/${id}/apply-errors/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function getApplyResultsVouchersImportResults(
  id: number
) {
  return request({
    url: `vouchers-processing/${id}/apply-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

// FAVA VOUCHER Details Importer

export async function uploadVouchersDetailsImportFiles(data: any) {
  return request({
    url: `voucher-details-processing/`,
    method: 'POST',
    data
  }) as AxiosPromise<AffiliateImporter>;
}

export async function getVouchersDetailsImportFiles(params: any) {
  return request({
    url: `voucher-details-processing/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<ProductsImporter>>;
}

export async function getVouchersDetailsImporterHistory(id: number) {
  return request({
    url: `voucher-details-processing/${id}/history/`,
    method: 'GET'
  }) as AxiosPromise<VouchersDetailsImporter[]>;
}

export async function simulateVouchersDetailsImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `voucher-details-processing/${id}/simulate/`,
    method: 'PATCH'
  });
}

export async function getSimulationVouchersDetailsImportResults(
  id: number
) {
  return request({
    url: `voucher-details-processing/${id}/simulation-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function cancelVouchersDetailsImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `voucher-details-processing/${id}/cancel/`,
    method: 'PUT'
  });
}

export async function getVouchersDetailsImportStatus(
  id: number
) {
  return request({
    url: `voucher-details-processing/${id}/status/`,
    method: 'GET'
  }) as AxiosPromise<ImporterStatus>;
}

export async function applyVouchersDetailsImport(
  id: number
): Promise<null | DetailError> {
  return safeRequest({
    url: `voucher-details-processing/${id}/apply/`,
    method: 'PATCH'
  });
}

export async function getApplyErrorsVouchersDetailsImportResults(
  id: number
) {
  return request({
    url: `voucher-details-processing/${id}/apply-errors/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}

export async function getApplyResultsVouchersDetailsImportResults(
  id: number
) {
  return request({
    url: `voucher-details-processing/${id}/apply-results/`,
    method: 'GET',
    responseType: 'blob'
  }) as AxiosPromise<Blob>;
}


export async function uploadAllowanceImportFiles(
  data: any
) {
  return request({
    url: `allowances/upload-resolution/`,
    method: 'POST',
    data
  }) as AxiosPromise;
}

export async function processIpsManualImportFiles(
  data: any
) {
  return request({
    url: `voluntary-payments/process-ips-files/`,
    method: 'POST',
    data,
    responseType: 'blob',
  }) as AxiosPromise;
}
